import React from "react";

const th = "bg-[#E9F1F4] border-b border-[#D2E0E6] text-[10px] uppercase tracking-[0.1em] text-[#47616B] py-2.5 px-3 whitespace-nowrap";
const td = "py-2 px-3 whitespace-nowrap text-sm border-b border-[#E6EEF1] mono";

const isNeg = (v) => typeof v === "string" && (v.trim().startsWith("-"));
const isPos = (v) => typeof v === "string" && v.includes("%") && !v.trim().startsWith("-") && v !== "0.00%";

export default function ReportGroups({ report }) {
  if (!report) return null;
  const { periods = [], groups = [] } = report;
  return (
    <div className="space-y-6" data-testid="report-groups">
      {groups.map((g) => (
        <div key={g.name} data-testid={`report-group-${g.name.replace(/\s+/g, "-").toLowerCase()}`}>
          <h3 className="trust-font text-base font-semibold text-[#0B2830] mb-2">{g.name}</h3>
          <div className="bg-white border border-[#D2E0E6] rounded-lg overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className={th + " text-left sticky left-0 bg-[#E9F1F4] z-10"}>Metric</th>
                  {periods.map((p) => (
                    <th key={p} className={th + " text-right"}>{p}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {g.rows.map((r) => (
                  <tr key={r.label} className="hover:bg-[#F5FAFB]">
                    <td className={td + " text-left text-[#0B2830] font-medium sticky left-0 bg-white"}>{r.label}</td>
                    {r.values.map((v, i) => (
                      <td key={periods[i] || i} className={td + " text-right"}
                        style={{ color: isNeg(v) ? "#E11D48" : isPos(v) ? "#059669" : "#47616B" }}>
                        {v}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
